<template>
  <icon-svg-base :class="$style.icon" :view-width="16" :view-height="16">
    <path
      :class="$style.icon__speechBalloon"
      d="M10.6663 8.66609C10.2983
    8.66609 9.99966 8.36743 9.99966 7.99943C9.99966 7.63143 10.2983 7.33276
    10.6663 7.33276C11.0343 7.33276 11.333 7.63143 11.333 7.99943C11.333 8.36743
    11.0343 8.66609 10.6663 8.66609ZM7.99966 8.66609C7.63166 8.66609 7.33299
    8.36743 7.33299 7.99943C7.33299 7.63143 7.63166 7.33276 7.99966
    7.33276C8.36766 7.33276 8.66632 7.63143 8.66632 7.99943C8.66632 8.36743
    8.36766 8.66609 7.99966 8.66609ZM5.33299 8.66609C4.96499 8.66609 4.66632
    8.36743 4.66632 7.99943C4.66632 7.63143 4.96499 7.33276 5.33299
    7.33276C5.70099 7.33276 5.99966 7.63143 5.99966 7.99943C5.99966 8.36743
    5.70099 8.66609 5.33299 8.66609ZM12.7137 3.28543C11.191 1.76276 9.08366
    1.08343 6.93099 1.41609C4.21299 1.84009 1.95966 4.02943 1.45099
    6.74076C1.20632 8.04609 1.34699 9.37543 1.85832 10.5841C1.92366 10.7374
    1.94366 10.8814 1.91766 11.0101L1.34632 13.8688C1.30232 14.0874 1.37099
    14.3134 1.52832 14.4708C1.65432 14.5968 1.82432 14.6661 1.99966
    14.6661C2.04299 14.6661 2.08699 14.6621 2.13032 14.6528L4.98566
    14.0821C5.14966 14.0508 5.30899 14.0968 5.41499 14.1408C6.62432 14.6521
    7.95366 14.7921 9.25832 14.5481C11.9697 14.0394 14.159 11.7861 14.583
    9.06809C14.9183 6.91609 14.237 4.80876 12.7137 3.28543Z"
    />
  </icon-svg-base>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconSpeechBalloon',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.icon {
  width: 1em;
  height: 1em;

  &__speechBalloon {
    color: inherit;
    fill: currentcolor;
  }
}
</style>
